<template>
    <select :value="modelValue" @change="$emit('update:modelValue', ($event?.target as HTMLInputElement)?.value)">
        <option value="" disabled selected hidden>Select Invoice Type...</option>
        <option
            v-for="jType in invoiceTypes"
            :value="jType.Canonical"
            :key="jType.Canonical"
        >
            {{ jType.DisplayShort }}
        </option>
    </select>
</template>
<script setup lang="ts">
import { JournalingType} from '@/models/Journaling/JournalingTypes';

const invoiceTypes: JournalingType[] = [
    new JournalingType("CAR_SALE_INVOICE", "CarSaleInvoice", "Car Sale Invoice", "Car Sale Invoice"),
    new JournalingType("COLLECTIVE_CAR_SALE_INVOICE", "CollectiveCarSaleInvoice", "Collective Car Sale Invoice", "Collective Car Sale Invoice"),
    new JournalingType("RECHARGE_INVOICE", "RechargeInvoice", "Recharge Invoice", "Recharge Invoice"),
    new JournalingType("SERVICE_INVOICE", "ServiceInvoice", "Service Invoice", "Service Invoice"),
    new JournalingType("CUSTOMER_INVOICE", "CustomerInvoice", "Customer Invoice", "Customer Invoice"),
    new JournalingType("CUSTOMER_CREDIT_NOTE", "CustomerCreditNote", "Customer Credit Note", "Customer Credit Note"),
    new JournalingType("CAR_SALE_CREDIT_NOTE", "CarSaleCreditNote", "Car Sale Credit Note", "Car Sale Credit Note"),
    new JournalingType("REMARKETING_INVOICE", "RemarketingInvoice", "Remarketing Invoice", "Remarketing Invoice"),
	new JournalingType("REMARKETING_CREDIT_NOTE", "RemarketingCreditNote", "Remarketing Credit Note", "Remarketing Credit Note"),
    new JournalingType("FINAL_SETTLEMENT_INVOICE", "FinalSettlementInvoice", "Final Settlement Invoice", "Final Settlement Invoice"),
    new JournalingType("COLLECTIVE_FINAL_SETTLEMENT_INVOICE", "CollectiveFinalSettlementInvoice", "Collective Final Settlement Invoice", "Collective Final Settlement Invoice")
];
defineProps<{
    modelValue?: string;
}>();
defineEmits<{
    (e:'update:modelValue', val: string);
}>();
</script>